import React, {useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./dropdown-section.css";
import classNames from "classnames";

const RollerButton = ({
    switchedIcon, 
    unswitchedIcon, switchedColor, 
    unswitchedColor, 
    switched
}) => {

   
    return (
        <div 
            className={classNames('switch-button',{'switched': switched})}
            style={{
                backgroundColor: switched ? switchedColor : unswitchedColor
            }}
        >
            <FontAwesomeIcon icon={switched ? switchedIcon : unswitchedIcon} />
        </div>
    )
}

export const ReactSwitch = ({
    switchedIcon, 
    unswitchedIcon, 
    switchedColor, 
    unswitchedColor,
    onSwitch,
    switched
}) => {
    
    const toggleSwitch = () => {
        onSwitch();
    };
    return (
        <div 
            className="switch-groove"
            onClick={toggleSwitch}
            style={{backgroundColor: switched ? unswitchedColor : switchedColor}}
        >
            <RollerButton 
                switchedIcon={switchedIcon} 
                unswitchedIcon={unswitchedIcon}
                switchedColor={switchedColor}
                unswitchedColor={unswitchedColor}
                switchMethod={toggleSwitch}
                switched={switched}
            />
        </div>
    )
}